import { gql } from '@apollo/client'

export const GET_ALL_GROUPS_CATEGORIES_SUB_LIST = gql`
  query GetAllGroupsCategoriesSubList(
    $offset: Int!
    $limit: Int!
    $searchQuery: String
  ) {
    getAllGroupsCategoriesSubList(
      offset: $offset
      limit: $limit
      searchQuery: $searchQuery
    ) {
      count
      rows {
        id
        group_category_id
        name
        description
        icon
        form_id
        icon_file_id
        allow_create_in_app
        allow_create_in_web
        show_system
        GroupsCategoriesSubToFile {
          id
          url
        }
        GroupCategoryOfGroupsCategoriesSub {
          id
          name
        }
      }
    }
  }
`

export const GET_ONE_GROUP_CATEGORY_SUB = gql`
  query GetOneGroupCategorySub($getOneGroupCategorySubId: Int!) {
    getOneGroupCategorySub(id: $getOneGroupCategorySubId) {
      id
      group_category_id
      name
      description
      icon
      form_id
      icon_file_id
      allow_create_in_app
      allow_create_in_web
      show_system
      GroupsCategoriesSubToFile {
        id
        url
      }
      GroupCategoryOfGroupsCategoriesSub {
        id
        name
      }
    }
  }
`

export const CREATE_GROUPS_CATEGORIES_SUB = gql`
  mutation CreateGroupsCategoriesSub($input: GroupsCategoriesSubInput!) {
    createGroupsCategoriesSub(input: $input) {
      id
      group_category_id
      name
      description
      icon
      form_id
      icon_file_id
      allow_create_in_app
      allow_create_in_web
      show_system
      GroupsCategoriesSubToFile {
        id
        url
      }
      GroupCategoryOfGroupsCategoriesSub {
        id
        name
      }
    }
  }
`

export const UPDATE_GROUPS_CATEGORIES_SUB = gql`
  mutation UpdateGroupsCategoriesSub(
    $updateGroupsCategoriesSubId: Int!
    $input: GroupsCategoriesSubInput!
  ) {
    updateGroupsCategoriesSub(id: $updateGroupsCategoriesSubId, input: $input)
  }
`

export const DELETE_GROUPS_CATEGORIES_SUB = gql`
  mutation DeleteGroupsCategoriesSub($deleteGroupsCategoriesSubId: Int!) {
    deleteGroupsCategoriesSub(id: $deleteGroupsCategoriesSubId)
  }
`

export const GET_ALL_FORMS = gql`
  query GetAllForms($searchQuery: String, $limit: Int, $offset: Int) {
    getAllForms(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      count
      rows {
        id
        name
      }
    }
  }
`
